import { systemRequest } from "./systemService";
import store from "../store/index";
import { data } from "jquery";

const isHOM = store.getters["app/isHOM"];
const isAndroid = store.getters["app/isAndroid"];
const isiPhone = store.getters["app/isIOS"];
const model = localStorage.getItem('phoneModel')
/**
 * 添加日历
 * @param {*} data
 * @returns
 */
export const ADDCALENDAR = data => {
  return systemRequest("addCalendar", data);
};
/**
 * 删除日历
 * @param {*} data
 * @returns
 */
export const DELETECALENDAR = data => {
  return systemRequest("deleteCalendar", data);
};
/**
 * 添加本地提醒
 * @param {*} data
 * @returns
 */
export const ADDSYSTEMREMINDER = data => {
  let model = localStorage.getItem('phoneModel')
  if (model == 'HOM') {
    return systemRequest("addSystemReminder", data);
  } else {
    return systemRequest("addNotification", data);
  }
};
/**
 * 删除本地提醒
 * @param {*} data
 * @returns
 */
export const DELETESYSTEMREMINDER= data => {
  let model = localStorage.getItem('phoneModel')
  if (model == 'HOM') {
    return systemRequest("deleteSystemReminder", data);
  } else {
    return systemRequest("deleteNotification", data);
  }
};


/**
 * 添加闹钟
 * @param {*} data
 * @returns
 */
export const ADDALARM = data => {
  return systemRequest("addAlarm", data);
};

/**
 * 拉起相机
 * @returns
 */
export const PHOTOGRAPH = (description) => {
  let model = localStorage.getItem('phoneModel')
  if (model == 'Android') {
    let data = {
      description
    };
    return systemRequest("takePhoto", data);
  } else {
    let data = {
      webAction: "photograph",
      description
    };
    return systemRequest("photograph", data);
  }
};

/**
 * 图片识别
 * @returns
 */
export const IMAGEIDENTIFY = (src) => {
  let data = {
    webAction: "imageIdentify",
    token: localStorage.getItem("token"),
    imgType: "",
    src
  };
  return systemRequest("imageIdentify", data);
};

/**
 * 刷新webView
 * @returns
 */
export const RELOAD = () => {
  let data = {
    webAction: "reload"
  };
  return systemRequest("reload", data);
};

/**
 * 跳转兔小槽
 * @param {*} data
 * @returns
 */
export const FEEDBACK = data => {
  if (model == 'HOM') {
    return systemRequest("feedback", data);
  } else if (model == 'Android') {
    return systemRequest("startFeedback", data);
  } else {
    return systemRequest("tuXiaoChao", data);
  }
};

/**
 * 获取状态栏高度
 * @param {*} data
 * @returns
 */
export const STATUSBARHIGHT = () => {
  return systemRequest("statusBarHight");
};

/**
 * 判断是否为鸿蒙系统
 * @returns
 */
export const GETSYSTEM = () => {
  let data = {
    webAction: "getSystem"
  };
  return systemRequest("getSystem", data);
};

/**
 *存储token
 *
 */

export const SETLOGINTOKEN = data => {
  return systemRequest("loginToken",data);
};

/**
 * 存储管家号
 *
 */
export const SETCONVERTID = data => {
  return systemRequest("saveConvertId",data);
};
/**
 * 退出登录 清除token
 *  */
export const SETLOGOUT = () => {
  let data = {
    webAction: "logout"
  };
  return systemRequest("logout",data);
};

/**
 *本地提醒列表
 *
 */

 export const GETNOTIFICATION = () => {
  let data = {
    webAction: "getNotification"
  };
  return systemRequest("getNotification",data);
};
/**
 *版本号
 *
 */

 export const GETVERSION = () => {
  let data = {
    webAction: "getVersion"
  };
  return systemRequest("getVersion",data);
};
/**
 * 跟ios传版本号
 */
export const GIVEVERSION = (data) => {
  return systemRequest("getWebVersion", data);
};
/**
 * 跳转应用商店 IOS
 * @param {*} data
 * @returns
 */
export const JUMPMARKET = () => {
  let data = {
    webAction: "jumpMarket"
  };
  return systemRequest("jumpMarket", data);
};

/*
  获取token
*/
export const GETTOKEN = () => {
  let data = {
    webAction: "getCrmToken"
  };
  return systemRequest("getCrmToken",data);
};



// WEBPACK FOOTER //
// ./src/systemFolder/SystemFuns.js